import type Employer from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-employer/types/Employer';

/**
 * Updates the app store's `formData.employer` property with data from the component.
 */
export default async (context:any) => {
    const moduleId = context.getters.moduleId;

    const data:Employer = {
        name            : context.rootState[`${ moduleId }_name`].value,
        phone           : context.rootState[`${ moduleId }_phone`].phoneNumber,
        ext             : context.rootState[`${ moduleId }_phone`].phoneExtension,
        email           : context.rootState[`${ moduleId }_email`].value,
        address1        : context.rootState[`${ moduleId }_address`].address1,
        address2        : context.rootState[`${ moduleId }_address`].address2,
        city            : context.rootState[`${ moduleId }_address`].city,
        state           : context.rootState[`${ moduleId }_address`].state,
        zip             : context.rootState[`${ moduleId }_address`].zip,
        locationAddress1: context.rootState[`${ moduleId }_location-address`].address1,
        locationAddress2: context.rootState[`${ moduleId }_location-address`].address2,
        locationCity    : context.rootState[`${ moduleId }_location-address`].city,
        locationState   : context.rootState[`${ moduleId }_location-address`].state,
        locationZip     : context.rootState[`${ moduleId }_location-address`].zip,
        contactFirstName: context.rootState[`${ moduleId }_contact-first-name`].value,
        contactLastName : context.rootState[`${ moduleId }_contact-last-name`].value,
        contactPhone    : context.rootState[`${ moduleId }_contact-phone`].phoneNumber,
    };

    await context.dispatch('updateData', {
        key  : 'employer',
        value: data,
    }, { root: true });
};